import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePageComponent } from './home-page/home-page.component';
import { NbAccordionModule, NbActionsModule, NbButtonGroupModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbDialogModule, NbDialogService, NbFormFieldModule, NbIconModule, NbInputModule, NbLayoutModule, NbMenuItem, NbMenuModule, NbPopoverModule, NbRadioModule, NbSelectModule, NbSidebarModule, NbStepperModule, NbTabsetModule, NbThemeModule, NbToggleModule, NbTooltipModule, NbTreeGridModule, NbContextMenuModule } from '@nebular/theme';
import { EditorsRoutingModule } from './editors-routing.module';
import { EditorsComponent } from './editors/editors.component';
import { LayoutEditorComponent } from './layout-editor/layout-editor.component';
import { HeaderEditorComponent } from './header-editor/header-editor.component';
import { FooterEditorComponent } from './footer-editor/footer-editor.component';
import { CategoryEditorComponent } from './category-editor/category-editor.component';
import { ProductEditorComponent } from './product-editor/product-editor.component';
import { CollapseSubmenuDirective } from './collapse-submenu.directive';
import { EditorContainerComponent } from '../editor-container/editor-container.component';
import { EditorContentDirective } from './directives/editor-content.directive';
import { EditorInputDirective } from './directives/editor-input.directive';
import { LayoutInputComponent } from './layout-editor/layout-input/layout-input.component';
import { HeaderInputComponent } from './header-editor/header-input/header-input.component';
import { FooterInputComponent } from './footer-editor/footer-input/footer-input.component';
import { HomeInputComponent } from './home-page/home-input/home-input.component';
import { ProductInputComponent } from './product-editor/product-input/product-input.component';
import { EditorInputContainerComponent } from '../editor-input-container/editor-input-container.component';
import { LayoutEditorService } from './layout-editor/layout-editor.service';
import { LogoNavigationComponent } from './header-editor/header-input/logo-navigation/logo-navigation.component';
import { MainNavigationComponent } from './header-editor/header-input/main-navigation/main-navigation.component';
import { ToolbarComponent } from './header-editor/header-input/toolbar/toolbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NoPaddingDirective } from './directives/no-padding.directive';
import { TabSetBackgroundDirective } from './directives/tab-set-background.directive';
import { ActiveStepperTextDirective } from './directives/active-stepper-text.directive';
import { MainHeaderComponent } from './header-editor/header-input/main-header/main-header.component';
import { TopHeaderComponent } from './header-editor/header-input/top-header/top-header.component';
import { BottomHeaderComponent } from './header-editor/header-input/bottom-header/bottom-header.component';
import { HeaderLayoutComponent } from './header-editor/header-input/header-layout/header-layout.component';
import { ScreenWidthComponent } from './layout-editor/layout-input/screen-width/screen-width.component';
import { PalletteComponent } from './layout-editor/layout-input/pallette/pallette.component';
import { EditorFooterComponent } from '../editor-footer/editor-footer.component';
import { EditorStepperComponent } from '../editor-stepper/editor-stepper.component';
import { EditorTabsetComponent } from '../editor-tabset/editor-tabset.component';
import { EditorInputHeaderComponent } from '../editor-input-header/editor-input-header.component';
import { EditorInlineFormComponent } from '../editor-inline-form/editor-inline-form.component';
import { EditorVerticalFormComponent } from '../editor-vertical-form/editor-vertical-form.component';
import { TopLeftComponent } from './header-editor/header-input/top-header/top-left/top-left.component';
import { TopCenterComponent } from './header-editor/header-input/top-header/top-center/top-center.component';
import { TopRightComponent } from './header-editor/header-input/top-header/top-right/top-right.component';
import { CorporateInfoComponent } from './footer-editor/footer-input/corporate-info/corporate-info.component';
import { CommercialPolicieaComponent } from './footer-editor/footer-input/commercial-policiea/commercial-policiea.component';
import { CustomerRelationsComponent } from './footer-editor/footer-input/customer-relations/customer-relations.component';
import { EditorContentCellComponent } from '../editor-content-cell/editor-content-cell.component';
import { HomeInputDefaultComponent } from './home-page/home-input/home-input-default/home-input-default.component';
import { HomeInputGridComponent } from './home-page/home-input/home-input-grid/home-input-grid.component';
import { HomeInputBannerComponent } from './home-page/home-input/home-input-banner/home-input-banner.component';
import { HomeInputSliderComponent } from './home-page/home-input/home-input-slider/home-input-slider.component';
import { HomeInputSlideshowComponent } from './home-page/home-input/home-input-slideshow/home-input-slideshow.component';
import { StorethemesModule } from '@urbannex/storethemes';
import { AddGridComponent } from './home-page/home-input/home-input-grid/add-grid/add-grid.component';
import { EditGridComponent } from './home-page/home-input/home-input-grid/edit-grid/edit-grid.component';
import { GridInputDialogComponent } from './home-page/home-input/home-input-grid/grid-input-dialog/grid-input-dialog.component';
import { SampleImageDirectoryComponent } from './sample-image-directory/sample-image-directory.component';
import { InputCellEditorComponent } from './home-page/home-input/home-input-grid/grid-input-dialog/input-cell-editor/input-cell-editor.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { PaddingElementValuesComponent } from './element-values/padding-element-values/padding-element-values.component';
import { MarginElementValuesComponent } from './element-values/margin-element-values/margin-element-values.component';
import { BackgroundElementValuesComponent } from './element-values/background-element-values/background-element-values.component';
import { FontElementValuesComponent } from './element-values/font-element-values/font-element-values.component';
import { ColorSketchModule } from 'ngx-color/sketch';
import { ColorCompactModule } from 'ngx-color/compact';
import { ColorGithubModule } from 'ngx-color/github';
import { ColorTwitterModule } from 'ngx-color/twitter';
import { ColorShadeModule } from 'ngx-color/shade';
import { FieldEditorComponent } from './field-editor/field-editor.component';
import { WidthInputComponent } from './field-editor/width-input/width-input.component';
import { BorderInputComponent } from './field-editor/border-input/border-input.component';
import { PaddingInputComponent } from './field-editor/padding-input/padding-input.component';
import { MarginInputComponent } from './field-editor/margin-input/margin-input.component';
import { BackgroundInputComponent } from './field-editor/background-input/background-input.component';
import { SeoInputComponent } from './field-editor/seo-input/seo-input.component';
import { ExpandFirstItemDirective } from './field-editor/directives/expand-first-item.directive';
import { TwitterColorDirective } from './field-editor/directives/twitter-color.directive';
import { EditorDialogComponent } from './dialogs/editor-dialog/editor-dialog.component';
import { SectionsEditorComponent } from './sections-editor/sections-editor.component';
import { SectionNavigatorComponent } from './sections-editor/section-navigator/section-navigator.component';
import { GridEditorComponent } from './sections-editor/grid-editor/grid-editor.component';
import { RowEditorComponent } from './sections-editor/row-editor/row-editor.component';
import { CellLayoutEditorComponent } from './cell-layout-editor/cell-layout-editor.component';
import { CellThemeEditorComponent } from './cell-theme-editor/cell-theme-editor.component';
import { SharedPreviewEditorComponent } from './shared-preview-editor/shared-preview-editor.component';
import { CellThemeEditorDirective } from './directives/cell-theme-editor.directive';
import { ThemeSwatchComponent } from './cell-theme-editor/theme-swatch/theme-swatch.component';
import { CellTextEditorComponent } from './cell-text-editor/cell-text-editor.component';
import { PreviewThemeBgDirective } from './directives/preview-theme-bg.directive';
import { BannerEditorComponent } from './sections-editor/banner-editor/banner-editor.component';
import { SingleMeasureComponent } from './field-editor/single-measure/single-measure.component';
import { MultiMeasureComponent } from './field-editor/multi-measure/multi-measure.component';
import { ThemeEditorComponent } from './theme-editor/theme-editor.component';
import { ThemeInputComponent } from './theme-editor/theme-input/theme-input.component';
import { ColoursComponent } from './theme-editor/theme-input/colours/colours.component';
import { TypographyComponent } from './theme-editor/theme-input/typography/typography.component';
import { ThemeColorPickerComponent } from './field-editor/theme-color-picker/theme-color-picker.component';
import { FontInputComponent } from './field-editor/font-input/font-input.component';
import { TestimonialEditorComponent } from './sections-editor/testimonial-editor/testimonial-editor.component';
import { BloglistEditorComponent } from './sections-editor/bloglist-editor/bloglist-editor.component';
import { TestimonialCellLayoutComponent } from './cell-layout-editor/testimonial-cell-layout/testimonial-cell-layout.component';
import { BannerCellLayoutComponent } from './cell-layout-editor/banner-cell-layout/banner-cell-layout.component';
import { CellBgEditorComponent } from './cell-bg-editor/cell-bg-editor.component';
import { ColorPickerPopoverComponent } from './dialogs/color-picker-popover/color-picker-popover.component';
import { FreeDraggingDirective } from './dialogs/free-dragging.directive';
import { DraggingHandleDirective } from './dialogs/dragging-handle.directive';
import { SizeShowSelectedDirective } from './shared-preview-editor/size-show-selected.directive';
import { BorderPresetPopoverComponent } from './dialogs/border-preset-popover/border-preset-popover.component';
import { PaddingPresetPopoverComponent } from './dialogs/padding-preset-popover/padding-preset-popover.component';
import { TestimonialPreviewComponent } from './shared-preview-editor/testimonial-preview/testimonial-preview.component';
import { ResolveElementIdDirective } from './shared-preview-editor/resolve-element-id.directive';
import { SectionEditorDialogComponent } from './dialogs/section-editor-dialog/section-editor-dialog.component';
import { SliderPopoverComponent } from './dialogs/slider-popover/slider-popover.component';
import { RowPreviewEditorComponent } from './shared-preview-editor/row-preview-editor/row-preview-editor.component';
import { RenderCellDirective } from './shared-preview-editor/render-cell.directive';
import { EditorIconsComponent } from './editor-icons/editor-icons.component';
import { FontSizePopoverComponent } from './dialogs/font-size-popover/font-size-popover.component';
import { FontWeightPopoverComponent } from './dialogs/font-weight-popover/font-weight-popover.component';
import { FontFamilyPopoverComponent } from './dialogs/font-family-popover/font-family-popover.component';
import { SitesPickerComponent } from './dialogs/sites-picker/sites-picker.component';
import { IntroSvgComponent } from './dialogs/intro-svg/intro-svg.component';
import { CategoryInputComponent } from './category-editor/category-input/category-input.component';
import { CategorySectionEditorComponent } from './sections-editor/category-section-editor/category-section-editor.component';
import { ProductSectionEditorComponent } from './sections-editor/product-section-editor/product-section-editor.component';
import { GalleryEditorComponent } from './sections-editor/product-section-editor/gallery-editor/gallery-editor.component';
import { ProductEditorDialogComponent } from './dialogs/product-editor-dialog/product-editor-dialog.component';
import { IdentificationEditorComponent } from './sections-editor/product-section-editor/identification-editor/identification-editor.component';
import { FeaturesEditorComponent } from './sections-editor/product-section-editor/features-editor/features-editor.component';
import { PriceEditorComponent } from './sections-editor/product-section-editor/price-editor/price-editor.component';
import { RatingsEditorComponent } from './sections-editor/product-section-editor/ratings-editor/ratings-editor.component';
import { PackagingEditorComponent } from './sections-editor/product-section-editor/packaging-editor/packaging-editor.component';
import { DescriptionEditorComponent } from './sections-editor/product-section-editor/description-editor/description-editor.component';
import { ReviewsEditorComponent } from './sections-editor/product-section-editor/reviews-editor/reviews-editor.component';
import { CartEditorComponent } from './cart-editor/cart-editor.component';
import { CartEditorInputComponent } from './cart-editor/cart-editor-input/cart-editor-input.component';
import { BlogEditorComponent } from './blog-editor/blog-editor.component';
import { BlogEditorInputComponent } from './blog-editor/blog-editor-input/blog-editor-input.component';
import { BorderElementValuesComponent } from './element-values/border-element-values/border-element-values.component';
import { LongDescriptionEditorComponent } from './sections-editor/product-section-editor/long-description-editor/long-description-editor.component';
import { ProductShareEditorComponent } from './sections-editor/product-section-editor/product-share-editor/product-share-editor.component';
import { ProductAddToCartComponent } from './sections-editor/product-section-editor/product-add-to-cart/product-add-to-cart.component';
import { TextareaPopoverComponent } from './dialogs/textarea-popover/textarea-popover.component';
import { HtmlFieldEditorComponent } from './field-editor/html-field-editor/html-field-editor.component';
import { HtmlPopoverComponent } from './dialogs/html-popover/html-popover.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { ElementButtonSelectorDirective } from './sections-editor/directives/element-button-selector.directive';
import { ProductClassificationComponent } from './sections-editor/product-section-editor/product-classification/product-classification.component';
import { BaseContentElementsEditorDirective } from './sections-editor/directives/base-content-elements-editor.directive';
import { SelectFieldEditorComponent } from './field-editor/select-field-editor/select-field-editor.component';
import { VariantEditorComponent } from './sections-editor/product-section-editor/variant-editor/variant-editor.component';
import { AddToCartEditorComponent } from './sections-editor/product-section-editor/add-to-cart-editor/add-to-cart-editor.component';
import { FieldSummaryPopoverComponent } from './dialogs/field-summary-popover/field-summary-popover.component';
import { BannerCellEditorComponent } from './sections-editor/grid-editor/banner-cell-editor/banner-cell-editor.component';
import { HomeProductListComponent } from './home-page/home-input/home-product-list/home-product-list.component';
import { InputHeaderComponent } from './home-page/home-input/input-header/input-header.component';
import { RowCellEditorComponent } from './sections-editor/row-editor/row-cell-editor/row-cell-editor.component';
import { TestimonialCellEditorComponent } from './sections-editor/testimonial-editor/testimonial-cell-editor/testimonial-cell-editor.component';
import { SliderEditorComponent } from './sections-editor/slider-editor/slider-editor.component';
import { SlideCellEditorComponent } from './sections-editor/slider-editor/slide-cell-editor/slide-cell-editor.component';
import { BannerLayoutTemplatesComponent } from './layout-editor/layout-templates/banner-layout-templates/banner-layout-templates.component';
import { ContentWidthSliderComponent } from './dialogs/content-width-slider/content-width-slider.component';
import { CellHeightPopoverComponent } from './dialogs/cell-height-popover/cell-height-popover.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { AboutUsInputComponent } from './about-us/about-us-input/about-us-input.component';
import { PoliciesEditorComponent } from './policies-editor/policies-editor.component';
import { PoliciesInputComponent } from './policies-editor/policies-input/policies-input.component';
import { HeaderThemeComponent } from './header-editor/header-input/header-theme/header-theme.component';
import { RadioOptionsComponent } from './field-editor/radio-options/radio-options.component';
import { ToggleSectionDirective } from './field-editor/theme-color-picker/toggle-section.directive';
import { ToggleComponent } from './field-editor/toggle/toggle.component';
import { TextColorPickerComponent } from './field-editor/text-color-picker/text-color-picker.component';
import { NavigationEditorComponent } from './navigation-editor/navigation-editor.component';
import { NavigationInputComponent } from './navigation-editor/navigation-input/navigation-input.component';
import { MenuItemNavigatorComponent } from './navigation-editor/navigation-input/menu-item-navigator/menu-item-navigator.component';
import { MenuItemEditorDialogComponent } from './navigation-editor/navigation-input/menu-item-editor-dialog/menu-item-editor-dialog.component';
import { AngularTreeGridModule } from 'angular-tree-grid';
import { TreeGridStylerDirective } from './navigation-editor/navigation-input/tree-grid-styler.directive';
import { FooterItemsComponent } from './footer-editor/footer-input/footer-items/footer-items.component';
import { DialogBackdropDirective } from './dialogs/dialog-backdrop.directive';
import { EditorTemplateOptionsComponent } from './dialogs/editor-dialog/editor-template-options/editor-template-options.component';
import { EditorDialogFooterComponent } from './dialogs/editor-dialog/editor-dialog-footer/editor-dialog-footer.component';
import { SharedSectionBuilderComponent } from './sections-editor/shared-section-builder/shared-section-builder.component';
import { BuilderHostDirective } from './sections-editor/shared-section-builder/builder-host.directive';
import { SectionCellStepperComponent } from './sections-editor/shared-section-builder/section-cell-stepper/section-cell-stepper.component';
import { ResolveContentElementEnumDirective } from './sections-editor/directives/resolve-content-element-enum.directive';
import { TransformContentElementEnumPipe } from './sections-editor/pipes/transform-content-element-enum.pipe';
import { BackgroundEditorComponent } from './sections-editor/shared-section-builder/section-builder-editors/background-editor/background-editor.component';
import { ImageEditorComponent } from './sections-editor/shared-section-builder/section-builder-editors/image-editor/image-editor.component';
import { OfbizFormsModule } from '@urbannex/ofbiz-forms';
import { BannerCellStepperComponent } from './sections-editor/shared-section-builder/section-cell-stepper/banner-cell-stepper/banner-cell-stepper.component';
import { ProductlinkCellStepperComponent } from './sections-editor/shared-section-builder/section-cell-stepper/productlink-cell-stepper/productlink-cell-stepper.component';
import { CallToActionCellStepperComponent } from './sections-editor/shared-section-builder/section-cell-stepper/call-to-action-cell-stepper/call-to-action-cell-stepper.component';
import { BlogArticleLinkStepperComponent } from './sections-editor/shared-section-builder/section-cell-stepper/blog-article-link-stepper/blog-article-link-stepper.component';
import { BaseStepperDirective } from './sections-editor/shared-section-builder/section-cell-stepper/base-stepper.directive';
import { BannerInputDialogComponent } from './home-page/home-input/home-input-banner/banner-input-dialog/banner-input-dialog.component';
import { BaseInputEditorDirective } from './base-input-editor.directive';
import { ProductListInputDialogComponent } from './home-page/home-input/home-product-list/product-list-input-dialog/product-list-input-dialog.component';
import { InputDialogWrapperComponent } from './wrappers/input-dialog-wrapper/input-dialog-wrapper.component';
import { ProductCellStepperComponent } from './sections-editor/shared-section-builder/section-cell-stepper/product-cell-stepper/product-cell-stepper.component';
import { HomeInputFeaturesComponent } from './home-page/home-input/home-input-features/home-input-features.component';
import { FeaturesInputDialogComponent } from './home-page/home-input/home-input-features/features-input-dialog/features-input-dialog.component';
import { FeatureCellStepperComponent } from './sections-editor/shared-section-builder/section-cell-stepper/feature-cell-stepper/feature-cell-stepper.component';
import { HomeInputTestimonialsComponent } from './home-page/home-input/home-input-testimonials/home-input-testimonials.component';
import { TestimononialsInputDialogComponent } from './home-page/home-input/home-input-testimonials/testimononials-input-dialog/testimononials-input-dialog.component';
import { TestimonialCellStepperComponent } from './sections-editor/shared-section-builder/section-cell-stepper/testimonial-cell-stepper/testimonial-cell-stepper.component';
import { HomeInputBloglistComponent } from './home-page/home-input/home-input-bloglist/home-input-bloglist.component';
import { BloglistInputDialogComponent } from './home-page/home-input/home-input-bloglist/bloglist-input-dialog/bloglist-input-dialog.component';
import { ImageStepComponent } from './sections-editor/shared-section-builder/section-cell-stepper/step-input-content/image-step/image-step.component';
import { HomeInputHeroImageComponent } from './home-page/home-input/home-input-hero-image/home-input-hero-image.component';
import { HeroImageInputDialogComponent } from './home-page/home-input/home-input-hero-image/hero-image-input-dialog/hero-image-input-dialog.component';
import { HeroImageCellStepperComponent } from './sections-editor/shared-section-builder/section-cell-stepper/hero-image-cell-stepper/hero-image-cell-stepper.component';
import { UnderlinePresetPopoverComponent } from './dialogs/underline-preset-popover/underline-preset-popover.component';
import { HeroImageLayoutTemplatesComponent } from './layout-editor/layout-templates/hero-image-layout-templates/hero-image-layout-templates.component';
import { BannerSectionOptionsComponent } from './sections-editor/section-options/banner-section-options/banner-section-options.component';
import { BloglistOptionsComponent } from './sections-editor/section-options/bloglist-options/bloglist-options.component';
import { CategoryOptionsComponent } from './sections-editor/section-options/category-options/category-options.component';
import { GridOptionsComponent } from './sections-editor/section-options/grid-options/grid-options.component';
import { ProductOptionsComponent } from './sections-editor/section-options/product-options/product-options.component';
import { RowOptionsComponent } from './sections-editor/section-options/row-options/row-options.component';
import { TestimonialOptionsComponent } from './sections-editor/section-options/testimonial-options/testimonial-options.component';
import { SliderOptionsComponent } from './sections-editor/section-options/slider-options/slider-options.component';
import { RichtextOptionsComponent } from './sections-editor/section-options/richtext-options/richtext-options.component';
import { BaseSectionOptionsComponent } from './sections-editor/section-options/base-section-options';
import { SectionPreviewComponent } from './dialogs/section-editor-dialog/section-preview/section-preview.component';
import { HeroImageOptionsComponent } from './sections-editor/section-options/hero-image-options/hero-image-options.component';
import { TextFieldEditorComponent } from './field-editor/text-field-editor/text-field-editor.component';
import { ContentElementFieldEditorComponent } from './field-editor/content-element-field-editor/content-element-field-editor.component';
import { TextEditorPopverComponent } from './dialogs/text-editor-popver/text-editor-popver.component';
import { InputFilterComponent } from './dialogs/font-family-popover/input-filter/input-filter.component';
import { VisibilityPopoverComponent } from './dialogs/visibility-popover/visibility-popover.component';
import { MenuItemPopoverDirective } from './directives/menu-item-popover.directive';
import { LayoutPopoverComponent } from './dialogs/layout-popover/layout-popover.component';
import { VerticalTabsDirective } from './../directives/vertical-tabs.directive';
import { MarginPopoverComponent } from './dialogs/margin-popover/margin-popover.component';
import { ActionPopoverComponent } from './dialogs/action-popover/action-popover.component';
import { LookupEntityComponent } from './dialogs/lookup-entity/lookup-entity.component';
import { LookupFormComponent } from './dialogs/lookup-entity/lookup-form/lookup-form.component';
import { LookupListComponent } from './dialogs/lookup-entity/lookup-list/lookup-list.component';
import { StyleContextMenuDirective } from '../directives/style-context-menu.directive';

@NgModule({
    declarations: [
        HomePageComponent,
        EditorsComponent,
        LayoutEditorComponent,
        HeaderEditorComponent,
        FooterEditorComponent,
        CategoryEditorComponent,
        ProductEditorComponent,
        CollapseSubmenuDirective,
        EditorContainerComponent,
        EditorInputContainerComponent,
        EditorFooterComponent,
        EditorInlineFormComponent,
        EditorVerticalFormComponent,
        EditorInputHeaderComponent,
        EditorStepperComponent,
        EditorTabsetComponent,
        EditorContentDirective,
        EditorInputDirective,
        LayoutInputComponent,
        HeaderInputComponent,
        FooterInputComponent,
        HomeInputComponent,
        ProductInputComponent,
        LogoNavigationComponent,
        MainNavigationComponent,
        ToolbarComponent,
        NoPaddingDirective,
        TabSetBackgroundDirective,
        ActiveStepperTextDirective,
        MainHeaderComponent,
        TopHeaderComponent,
        BottomHeaderComponent,
        HeaderLayoutComponent,
        ScreenWidthComponent,
        PalletteComponent,
        TopLeftComponent,
        TopCenterComponent,
        TopRightComponent,
        CorporateInfoComponent,
        CommercialPolicieaComponent,
        CustomerRelationsComponent,
        EditorContentCellComponent,
        HomeInputDefaultComponent,
        HomeInputGridComponent,
        HomeInputBannerComponent,
        HomeInputSliderComponent,
        HomeInputSlideshowComponent,
        AddGridComponent,
        EditGridComponent,
        GridInputDialogComponent,
        SampleImageDirectoryComponent,
        InputCellEditorComponent,
        PaddingElementValuesComponent,
        MarginElementValuesComponent,
        BackgroundElementValuesComponent,
        FontElementValuesComponent,
        FieldEditorComponent,
        WidthInputComponent,
        BorderInputComponent,
        PaddingInputComponent,
        MarginInputComponent,
        BackgroundInputComponent,
        SeoInputComponent,
        ExpandFirstItemDirective,
        TwitterColorDirective,
        EditorDialogComponent,
        SectionsEditorComponent,
        SectionNavigatorComponent,
        GridEditorComponent,
        RowEditorComponent,
        CellLayoutEditorComponent,
        CellThemeEditorComponent,
        SharedPreviewEditorComponent,
        CellThemeEditorDirective,
        ThemeSwatchComponent,
        CellTextEditorComponent,
        PreviewThemeBgDirective,
        BannerEditorComponent,
        SingleMeasureComponent,
        MultiMeasureComponent,
        ThemeEditorComponent,
        ThemeInputComponent,
        ColoursComponent,
        TypographyComponent,
        ThemeColorPickerComponent,
        FontInputComponent,
        TestimonialEditorComponent,
        BloglistEditorComponent,
        TestimonialCellLayoutComponent,
        BannerCellLayoutComponent,
        CellBgEditorComponent,
        ColorPickerPopoverComponent,
        FreeDraggingDirective,
        DraggingHandleDirective,
        SizeShowSelectedDirective,
        BorderPresetPopoverComponent,
        PaddingPresetPopoverComponent,
        TestimonialPreviewComponent,
        ResolveElementIdDirective,
        SectionEditorDialogComponent,
        SliderPopoverComponent,
        RowPreviewEditorComponent,
        RenderCellDirective,
        EditorIconsComponent,
        FontSizePopoverComponent,
        FontWeightPopoverComponent,
        FontFamilyPopoverComponent,
        SitesPickerComponent,
        IntroSvgComponent,
        CategoryInputComponent,
        CategorySectionEditorComponent,
        ProductSectionEditorComponent,
        GalleryEditorComponent,
        ProductEditorDialogComponent,
        IdentificationEditorComponent,
        FeaturesEditorComponent,
        PriceEditorComponent,
        RatingsEditorComponent,
        PackagingEditorComponent,
        DescriptionEditorComponent,
        ReviewsEditorComponent,
        CartEditorComponent,
        CartEditorInputComponent,
        BlogEditorComponent,
        BlogEditorInputComponent,
        BorderElementValuesComponent,
        LongDescriptionEditorComponent,
        ProductShareEditorComponent,
        ProductAddToCartComponent,
        TextareaPopoverComponent,
        HtmlFieldEditorComponent,
        HtmlPopoverComponent,
        ElementButtonSelectorDirective,
        ProductClassificationComponent,
        BaseContentElementsEditorDirective,
        SelectFieldEditorComponent,
        VariantEditorComponent,
        AddToCartEditorComponent,
        FieldSummaryPopoverComponent,
        BannerCellEditorComponent,
        HomeProductListComponent,
        InputHeaderComponent,
        RowCellEditorComponent,
        TestimonialCellEditorComponent,
        SliderEditorComponent,
        SlideCellEditorComponent,
        BannerLayoutTemplatesComponent,
        ContentWidthSliderComponent,
        CellHeightPopoverComponent,
        AboutUsComponent,
        AboutUsInputComponent,
        PoliciesEditorComponent,
        PoliciesInputComponent,
        HeaderThemeComponent,
        RadioOptionsComponent,
        ToggleSectionDirective,
        ToggleComponent,
        TextColorPickerComponent,
        NavigationEditorComponent,
        NavigationInputComponent,
        MenuItemNavigatorComponent,
        MenuItemEditorDialogComponent,
        TreeGridStylerDirective,
        FooterItemsComponent,
        DialogBackdropDirective,
        EditorTemplateOptionsComponent,
        EditorDialogFooterComponent,
        SharedSectionBuilderComponent,
        BuilderHostDirective,
        SectionCellStepperComponent,
        ResolveContentElementEnumDirective,
        TransformContentElementEnumPipe,
        BackgroundEditorComponent,
        ImageEditorComponent,
        BannerCellStepperComponent,
        ProductlinkCellStepperComponent,
        CallToActionCellStepperComponent,
        BlogArticleLinkStepperComponent,
        BaseStepperDirective,
        BannerInputDialogComponent,
        BaseInputEditorDirective,
        ProductListInputDialogComponent,
        InputDialogWrapperComponent,
        ProductCellStepperComponent,
        HomeInputFeaturesComponent,
        FeaturesInputDialogComponent,
        FeatureCellStepperComponent,
        HomeInputTestimonialsComponent,
        TestimononialsInputDialogComponent,
        TestimonialCellStepperComponent,
        HomeInputBloglistComponent,
        BloglistInputDialogComponent,
        ImageStepComponent,
        HomeInputHeroImageComponent,
        HeroImageInputDialogComponent,
        HeroImageCellStepperComponent,
        UnderlinePresetPopoverComponent,
        HeroImageLayoutTemplatesComponent,
        BannerSectionOptionsComponent,
        BloglistOptionsComponent,
        CategoryOptionsComponent,
        GridOptionsComponent,
        ProductOptionsComponent,
        RowOptionsComponent,
        TestimonialOptionsComponent,
        SliderOptionsComponent,
        RichtextOptionsComponent,
        BaseSectionOptionsComponent,
        SectionPreviewComponent,
        HeroImageOptionsComponent,
        TextFieldEditorComponent,
        ContentElementFieldEditorComponent,
        TextEditorPopverComponent,
        InputFilterComponent,
        VisibilityPopoverComponent,
        MenuItemPopoverDirective,
        LayoutPopoverComponent,
        VerticalTabsDirective,
        MarginPopoverComponent,
        ActionPopoverComponent,
        LookupEntityComponent,
        LookupFormComponent,
        LookupListComponent,
        StyleContextMenuDirective
    ],
    exports: [EditorsComponent, HomePageComponent, EditorContainerComponent, EditorContentDirective, LayoutEditorComponent,
        HeaderEditorComponent,
        FooterEditorComponent,
        EditorInputDirective,
        LayoutInputComponent,
        HeaderInputComponent,
        FooterInputComponent,
        EditorInputContainerComponent,
        ThemeEditorComponent,
        ColorPickerPopoverComponent,
        CartEditorComponent,
        PoliciesEditorComponent, StyleContextMenuDirective
    ],
    imports: [
        CommonModule,
        FormsModule,
        NbLayoutModule,
        NbButtonModule,
        NbButtonGroupModule,
        NbCheckboxModule,
        NbFormFieldModule,
        NbPopoverModule,
        NbThemeModule,
        NbMenuModule,
        NbContextMenuModule,
        NbSidebarModule.forRoot(),
        NbSelectModule,
        NbRadioModule,
        NbTabsetModule,
        NbIconModule,
        NbInputModule,
        NbStepperModule,
        NbTooltipModule,
        NbToggleModule,
        NbActionsModule,
        StorethemesModule,
        NbDialogModule.forRoot(),
        NbCardModule,
        NbAccordionModule,
        NgxSliderModule,
        FormsModule,
        ReactiveFormsModule,
        ColorSketchModule,
        ColorTwitterModule,
        ColorCompactModule,
        ColorGithubModule,
        ColorShadeModule,
        EditorModule,
        NbTreeGridModule,
        AngularTreeGridModule,
        OfbizFormsModule.forRoot("https://kwikstore-dev:8443/rest/")
    ]
})
export class EditorsModule {
    static forRoot(): ModuleWithProviders<EditorsModule> {
        return {
            ngModule: EditorsModule,
            providers: [LayoutEditorService,
                { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
            ]
        };
    }
}
